import React from "react";
import ApexChart from "./apex-chart";

class ApexChartController extends React.Component{

    closeInfo = () => {

    }

    showInfo = (title) => {
        this.props.modalShowToggle('chartInfo', true, this.closeInfo, this.props.getValue(title), title);
    }

    render(){
        return(
            <ApexChart {...this.props} showInfo={this.showInfo}/>
        )
    }
}

export default ApexChartController;